import $ from "jquery";
import '../../../../node_modules/jquery-mask-plugin/src/jquery.mask';

/// Adds a mask to a phone input field using format (000) 111-2222
/// Adds a aria-label to the input element for proper sounding phone number (with pauses)
/// Ported from Service Request UI
export function PhoneMask()
{
    var obj = {
        AddPhoneMaskById: addPhoneMaskById,
        AddPhoneMaskByElement: addPhoneMaskByElement
    }
    return obj;

    function addPhoneMaskById(id)
    {
        let element = $('#' + id);
        obj.addPhoneMaskByElement(element);
    }
    
    function addPhoneMaskByElement($element)
    {
        $element.mask('(000) 000-0000');
        $element.change(function()
        {
            var value = $element.val();
            value = value.replace(/\D/g, "");
            if (value && value.length == 10)
            {
                $(this).attr("aria-label",formatForWCAG(value))
            }
        
            function formatForWCAG(phone)
            {
                if (phone && phone.length == 10)
                {
                    // format: "0 0 0. 0 0 0. 0 0 0 0.";
                    return phone[0] + " " + phone[1] + " " + phone[2] + ". " + phone[3] + " " + phone[4] + " " + phone[5] + ". " + + phone[6] + " " + phone[7] + " " + phone[8] + " " + phone[9] + ".";
                }
            }
        })
    }
}

export default PhoneMask;
